
import { useState } from "react";
import { getTestPoints } from "@/utils/level3/points";
import { getMaxAttempts } from "@/utils/level1/maxAttempts";

interface ToastProps {
  title: string;
  description: string;
  variant?: "default" | "destructive";
}

export const usePointNavigation = (
  toast: (props: ToastProps) => void
) => {
  const [selectedTest, setSelectedTest] = useState<string | null>(null);
  const [currentPoint, setCurrentPoint] = useState<string>("");
  const [currentAttempt, setCurrentAttempt] = useState<number>(0);

  const resetNavigation = (testId: string) => {
    console.log(`Resetting navigation for test: ${testId}`);
    const points = getTestPoints(testId);
    console.log(`Getting points for test ${testId} at level ${getCurrentLevel()}`);
    console.log(`moveToNextAttempt - points: ${points}`);
    
    if (points && points.length > 0) {
      // Always start with the first point of the specific test
      setCurrentPoint(points[0]);
      setCurrentAttempt(0);
    }
  };

  const moveToNextAttempt = () => {
    console.log(`moveToNextAttempt - currentAttempt: ${currentAttempt}`);
    const maxAttempts = getMaxAttempts(selectedTest);
    console.log(`moveToNextAttempt - maxAttempts: ${maxAttempts}`);
    console.log(`moveToNextAttempt - currentPoint: ${currentPoint}`);
    
    if (!selectedTest) return false;
    
    // Get the correct points for this test
    const points = getTestPoints(selectedTest);
    console.log(`Getting points for test ${selectedTest} at level ${getCurrentLevel()}`);
    console.log(`moveToNextAttempt - points: ${points}`);

    if (currentAttempt < maxAttempts - 1) {
      // Move to the next attempt within the current point
      setCurrentAttempt(currentAttempt + 1);
      return true;
    }
    
    // If we've reached the max attempts for this point, move to the next point
    const currentIndex = points.indexOf(currentPoint);
    
    if (currentIndex < points.length - 1) {
      // Move to the first attempt of the next point
      setCurrentPoint(points[currentIndex + 1]);
      setCurrentAttempt(0);
      return true;
    }
    
    // If we're at the last point and last attempt, we're done
    toast({
      title: "Exercice terminé",
      description: "Vous avez complété tous les essais pour ce test. Vous pouvez maintenant consulter vos résultats.",
    });
    
    return false;
  };
  
  const moveToPreviousAttempt = () => {
    if (!selectedTest) return false;
    
    const points = getTestPoints(selectedTest);
    
    if (currentAttempt > 0) {
      // Move to the previous attempt within the current point
      setCurrentAttempt(currentAttempt - 1);
      return true;
    }
    
    // If we're at the first attempt of this point, try to move to the previous point
    const currentIndex = points.indexOf(currentPoint);
    
    if (currentIndex > 0) {
      // Move to the last attempt of the previous point
      setCurrentPoint(points[currentIndex - 1]);
      setCurrentAttempt(9); // 10 attempts per point (0-9)
      return true;
    }
    
    // If we're at the first point and first attempt, we can't go back
    return false;
  };
  
  // Helper function to get current level from URL
  const getCurrentLevel = () => {
    const path = window.location.pathname;
    if (path.includes('level1')) return 1;
    if (path.includes('level2')) return 2;
    return 3;
  };

  return {
    selectedTest,
    setSelectedTest,
    currentPoint,
    setCurrentPoint,
    currentAttempt,
    setCurrentAttempt,
    moveToNextAttempt,
    moveToPreviousAttempt,
    resetNavigation
  };
};
